export default __webpack_public_path__ + "static/media/Ema_logo_white.3d2053e4.png";